import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";
import ScrollArea from "react-scrollbar";
import {constants} from '../containers/common/commonExport';

const Activities = (props) => (
  <div>
    <div className={"activitiesLeft " + (props.isFRAReport == true ? "FRAPrentBorder " : '') + (props.certifyStatus == constants.UNCERTIFIED 
      && props.claimStatus != constants.PENDING_CLAIM
      && props.claimStatus != constants.ACCEPTED_CLAIM
      && props.claimStatus != constants.REJECTED_CLAIM && props.role == constants.roles.EMPLOYEE_ROLE && (props.comments && props.comments != "NULL") && !props.isLogUser ? "col-sm-7" : "col-sm-12")}>
        <div className="activitiesTbl">
          {
            props.isLogUser ? props.renderWorkDayActLogs() : <div />
          }
          <Table className={props.isLogUser ? "mainTblHead LogTable table-striped table-bordered table-condensed" :"mainTblHead table-striped table-bordered table-condensed"}>
            <Thead>
              <Tr>
                <Th className={props.isLogUser ? "hoslogtablecolactivity" : "header activityName"}>Activity</Th>
                <Th className={props.isLogUser ? "logTime" : "hidden"}>Start Location</Th>
                <Th className={props.isLogUser ? "logTime" : "hidden"}>End Location</Th>
                <Th className={props.isLogUser && props.isEdit ? "logTime" : "hidden"}> Type </Th>
                <Th className={props.isLogUser ? "logTime" :"header activityTime"}>Start Time</Th>
                <Th className={props.isLogUser ? "logTime" :"header activityTime"}>End Time</Th>
                <Th className={((props.eventKey == 1 && props.role == constants.roles.EMPLOYEE_ROLE) || props.isLogUser) ? "hidden" : "header miscTime"}>MISC</Th>
                <Th className={(props.showAction == false || props.isFRAReport == true || (props.isLogUser && !props.isEdit)) ? 'hidden' : 'activityActions' }>{""}</Th>
              </Tr>
            </Thead>
          </Table>
          <ScrollArea
            ref={props.scrollContainer}
            speed={0.8}
            className={props.isFRAReport == true ? "" : props.isLogUser ? "scroll-bar-hoslog" : "scroll-bar"}
            contentClassName="content"
            horizontal={false}
          >
            <Table className="table table-striped  table-condensed">
              <Thead className="hidden">
                <Tr>
                  <Th className={props.isLogUser ? "hoslogtablecolactivity" : "header"}>Activity</Th>
                  <Th className={props.isLogUser ? "logTime" : "hidden"}> From Location </Th>
                  <Th className={props.isLogUser ? "logTime" : "hidden"}> To Location </Th>
                  <Th className={props.isLogUser ? "logTime" : "hidden"}> Type </Th>
                  <Th className={props.isLogUser ? "logTime" :"header"}>Start Time</Th>
                  <Th className={props.isLogUser ? "logTime" :"header"}>End Time</Th>
                  <Th className={props.eventKey == 1 || props.isLogUser ? "hidden" : "header"}>MISC</Th>
                  <Th className={(props.showAction == false || props.isFRAReport == true || (props.isLogUser && !props.isEdit)) ? 'hidden' : 'activityActions' }>{""}</Th>
                </Tr>
              </Thead>
              <Tbody>{props.renderActivities(props.defaultWorkday)}</Tbody>
            </Table>
          </ScrollArea>
        </div>
        <div className="row margin-right-0">{props.renderAddButton()}</div>
        <div className={props.isLogUser && props.deadheadWarning && !props.isFRAReport ? "deadheadWarning alert alert-warning" : "hidden"}>
          <strong>WARNING ! </strong> {props.deadheadMessage}
        </div>
        {
          (props.isLogUser || props.isFRAReport) && props.renderCommentsSectionLogs(props.comments)
        }
        <div className="workdayDetails">
          { !props.isLogUser && props.renderWorkdayDetails() }
          {props.role != constants.roles.ADMIN_ROLE &&
          props.certifyStatus == constants.CLAIM && !props.isLogUser ? (
            <div className="pendingValidation">Pending Verification</div>) : ("")}
        </div>
        <div>{props.adjustedHOS && !props.isLogUser? props.renderCommentBox() : ""}</div>

      </div>
      {
        !props.isLogUser && props.claimStatus != constants.PENDING_CLAIM 
        && props.claimStatus != constants.ACCEPTED_CLAIM
        && props.claimStatus != constants.REJECTED_CLAIM && props.renderLogs()
      }
      </div>
      
);

export default Activities;
